// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class DevicePasswordResource extends Resource {
    basePath: string = 'devices/password/';

    objectPath: string = 'devices/password/{ident}/';
}
